import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/**
 * El efectivo de la casa: dónde está, el excedente de cada noche y los arqueos. Desde el 2026-10-04 se ve
 * igual para todos los roles, y el libro del mes vive aparte en `/caja-ahorro`, de Contabilidad.
 */
export const rutaEfectivo = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/efectivo',
  component: lazyRouteComponent(() => import('../_contabilidad/caja-ahorro-pantalla.js'), 'RutaEfectivo'),
});
